import { Injectable } from '@angular/core';
import { config } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { Sucursal } from '../classes/sucursal';
import { Categoria } from '../classes/categoria';
import { Producto } from '../classes/producto';
import { Subcategoria } from '../classes/subcategoria';

@Injectable({
  providedIn: 'root',
})
export class SucursalService {

  API = `${config.apiURL}/api/sucursal`;
  APP = config.appID;

  constructor(private http: HttpClient) {}

  getSucursal(id: number) {
    const promise = new Promise((resolve, reject) => {
      this.http.get<Sucursal[]>(`${this.API}/${id}`).subscribe(
        (data) => {
          // Success
          resolve(data);
        },
        (error) => {
          console.log('Error Service', error);
          reject(error);
        }
      );
    });
    return promise;
  }

  getSucursalesCiudades() {
    const promise = new Promise((resolve, reject) => {
      this.http.get<Sucursal[]>(`${this.API}/ciudades/${this.APP}`).subscribe(
        (data) => {
          // Success
          resolve(data);
        },
        (error) => {
          console.log('Error Service', error);
          reject(error);
        }
      );
    });
    return promise;
  }

  getSucursales(value: string) {
    const promise = new Promise((resolve, reject) => {
      this.http.get<Sucursal[]>(`${this.API}/ciudad/${this.APP}/${value}`).subscribe(
        (data) => {
          // Success
          resolve(data);
        },
        (error) => {
          console.log('Error Service', error);
          reject(error);
        }
      );
    });
    return promise;
  }

  getSucursalCategorias(id: number) {
    const promise = new Promise((resolve, reject) => {
      this.http.get<Categoria[]>(`${this.API}/categorias/${id}`).subscribe(
        (data) => {
          // Success
          resolve(data);
        },
        (error) => {
          console.log('Error Service', error);
          reject(error);
        }
      );
    });
    return promise;
  }

  getSucursalProductos(id: number, subcategoria: number) {
    const promise = new Promise((resolve, reject) => {
      this.http.get<Producto[]>(`${this.API}/productos/${id}/${subcategoria}`).subscribe(
        (data) => {
          // Success
          resolve(data);
        },
        (error) => {
          console.log('Error Service', error);
          reject(error);
        }
      );
    });
    return promise;
  }

  getSucursalSubcategoria(id: number, categoria: number) {
    const promise = new Promise((resolve, reject) => {
      this.http.get<Subcategoria[]>(`${this.API}/subcategoria/${id}/${categoria}`)
        .subscribe(data => {
          // Success
          resolve(data);
        },
        error => {
          console.log('Error Service', error);
          reject(error);
        }
      );
    });
    return promise;
  }

  getSucursalProducto(id: number, sucursal: number) {
    const promise = new Promise((resolve, reject) => {
      this.http.get<Producto[]>(`${this.API}/producto_precio/${id}/${sucursal}`).subscribe(
        (data) => {
          // Success
          resolve(data);
        },
        (error) => {
          console.log('Error Service', error);
          reject(error);
        }
      );
    });
    return promise;
  }
}
